import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptorInterceptor } from '../error-interceptor.interceptor';

export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptorInterceptor,
    multi: true,
  },
];

@NgModule({
  imports: [HttpClientModule],
  providers: [httpInterceptorProviders],
})
export class ErrorInterceptorModule {}
